import type { Gender, PartnerType } from '../../app/api/generated/client';

export type SourceRelation = {
    partnerUuid: string;
    globalPartnerId?: string;
    fullName: string;
    relationUuid?: string;
};

export enum PreselectedRelationshipType {
    IS_SPOUSE = 'IS_SPOUSE',
    IS_PARENT = 'IS_PARENT',
    IS_CHILD = 'IS_CHILD',
}

export type PartnerDTO = {
    globalPartnerId?: string;
    techId?: string;
    fullName: string;
    firstName?: string;
    lastName?: string;
    partnerType?: PartnerType;
    nationality?: string[];
    mainDomicileCountry?: string;
    mainDomicileCity?: string;
    dateOfBirth?: string;
    dateOfDeath?: string;
    gender?: Gender;
    relationshipManager?: string;
};
